/*
 * Toolworld – produktside. Indlæses kun på produktsider af snippets/tw-scripts.liquid.
 *
 * Fælles: onVariantChange() kalder komponenterne, når den valgte variant skifter.
 * R2: varenr. og EAN · lagerstatus · billede viser standardfarven · R7 Læs mere og sektionslinks · R8 Vis alle
 * R13 (mobil): prikker i galleriet og køb-bar i bunden. R10: serievælger og filter.
 */
(function () {
  'use strict';

  // Hjælpere

  function jsonData(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  }

  function productForm() {
    return document.querySelector('.js-product-section--product [data-product-form]');
  }

  var mobile = window.matchMedia('(max-width: 798px)');

  // Variantskift: Turbo sætter master-select'ens værdi via OptionSelectors uden altid at
  // sende 'change', så vi lytter på ændringer og klik i formularen og tjekker værdien bagefter.

  var variantListeners = [];

  function onVariantChange(fn) {
    variantListeners.push(fn);
  }

  function initVariantWatcher() {
    var form = productForm();
    var master = form && form.querySelector('[name="id"]');
    if (!master) return;
    var current = master.value;
    function sync() {
      if (master.value === current) return;
      current = master.value;
      variantListeners.forEach(function (fn) {
        fn(current);
      });
    }
    form.addEventListener('change', function () {
      window.setTimeout(sync, 0);
    });
    form.addEventListener('click', function () {
      window.setTimeout(sync, 0);
    });
  }

  // R2 – varenr. og EAN følger den valgte variant

  function initVariantIds() {
    var data = jsonData('[data-tw-variant-ids-data]');
    var line = document.querySelector('[data-tw-variant-ids]');
    if (!data || !line) return;
    onVariantChange(function (id) {
      var ids = data[id];
      if (!ids) return;
      var sku = ids.sku || '';
      var ean = ids.ean || '';
      // Både linjen under titlen og rækkerne i specifikationstabellen
      Array.prototype.forEach.call(document.querySelectorAll('[data-tw-sku]'), function (el) {
        el.textContent = sku;
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-tw-ean]'), function (el) {
        el.textContent = ean;
      });
      setHidden(line.querySelector('[data-tw-sku-wrap]'), !sku);
      setHidden(line.querySelector('[data-tw-ean-wrap]'), !ean);
      setHidden(line.querySelector('[data-tw-ids-sep]'), !(sku && ean));
      setHidden(line, !(sku || ean));
    });
  }

  // Lagerstatus følger den valgte variant (snippets/tw-stock.liquid)

  // Samme linje i prisboksen og i køb-baren på mobil. Leveringstiden er pr. vare og følger statussen:
  // "Leveres på …" ved på lager, "Vi kontakter dig med forventet levering" ved restordre og bestillingsvare (lager 0, kan
  // købes; Johan 2026-10-24), intet ved udsolgt.
  function initStock() {
    var data = jsonData('[data-tw-stock-data]');
    var els = document.querySelectorAll('[data-tw-stock]');
    if (!data || !els.length) return;
    onVariantChange(function (id) {
      if (!(id in data)) return;
      var state = data[id];
      Array.prototype.forEach.call(els, function (el) {
        var compact = el.classList.contains('tw-stock--compact');
        el.className = 'tw-stock tw-stock--' + state + (compact ? ' tw-stock--compact' : '');
        var label = el.getAttribute('data-label-' + state) || '';
        el.querySelector('[data-tw-stock-label]').textContent = label;
        setHidden(el, !label);
        // 'supplier' (lager føres ikke): leveringstiden er selve teksten, ingen ekstra linje bagefter
        var suffix = state === 'sold_out' || state === 'supplier' ? '' :
          el.getAttribute(state === 'restordre' || state === 'bestillingsvare' ? 'data-expected' : 'data-delivery');
        var delivery = el.querySelector('[data-tw-stock-delivery]');
        delivery.textContent = suffix ? ' · ' + suffix : '';
        setHidden(delivery, !suffix);
      });
    });
  }

  // "Billedet viser standardfarven." (snippets/tw-billede-note.liquid): linjen flyttes ind under galleriet og
  // vises kun for varianter uden eget foto (variant-metafeltet toolworld.billede_standardfarve).
  function initBilledeNote() {
    var note = document.querySelector('[data-tw-billede-note]');
    if (!note) return;
    var gallery = document.querySelector('.js-product-section--product [data-product-gallery-wrapper]') ||
      document.querySelector('[data-product-gallery-wrapper]');
    if (gallery && gallery.parentNode) {
      gallery.parentNode.insertBefore(note, gallery.nextSibling);
    }
    var data = jsonData('[data-tw-billede-note-data]');
    if (!data) return;
    onVariantChange(function (id) {
      if (id in data) setHidden(note, !data[id]);
    });
  }

  // R13 – køb-bar i bunden på mobil, når køb-knappen er scrollet ud af syne

  function initStickyAtc() {
    var bar = document.querySelector('[data-tw-sticky-atc]');
    var form = productForm();
    var realButton = form && form.querySelector('.add_to_cart');
    if (!bar || !realButton) return;
    var addButton = bar.querySelector('[data-tw-sticky-add]');
    var priceEl = bar.querySelector('[data-tw-sticky-price]');
    var data = jsonData('[data-tw-sticky-data]');
    var buttonAbove = false;

    function update() {
      var show = mobile.matches && buttonAbove;
      bar.classList.toggle('tw-sticky-atc--visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      addButton.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('tw-has-sticky-atc', show);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        // Kun når knappen er over skærmen (scrollet forbi) – ikke før man er nået ned til den
        buttonAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      }).observe(realButton);
    }
    if (mobile.addEventListener) mobile.addEventListener('change', update);

    addButton.addEventListener('click', function () {
      realButton.click();
    });

    if (data) {
      onVariantChange(function (id) {
        var v = data[id];
        if (!v) return;
        if (priceEl && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          priceEl.innerHTML = window.Shopify.formatMoney(v.price, document.body.getAttribute('data-money-format'));
        }
        addButton.disabled = !v.available;
        addButton.textContent = v.available ? addButton.dataset.labelAdd : addButton.dataset.labelSoldOut;
      });
    }
  }

  // R13 – prikker i stedet for miniaturer på mobil (Turbo har pageDots: false hardcodet)

  function flickityFor(el) {
    if (window.Flickity && typeof window.Flickity.data === 'function' && window.Flickity.data(el)) {
      return window.Flickity.data(el);
    }
    if (window.jQuery) return window.jQuery(el).data('flickity');
    return null;
  }

  function initGalleryDots() {
    var gallery = document.querySelector('.js-product-section--product .product_gallery');
    if (!gallery) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      var flkty = flickityFor(gallery);
      if (!flkty && ++tries < 50) return;
      window.clearInterval(timer);
      if (flkty) buildDots(gallery, flkty);
    }, 100);
  }

  function buildDots(gallery, flkty) {
    var count = flkty.cells ? flkty.cells.length : 0;
    if (count < 2 || gallery.parentNode.querySelector('.tw-gallery-dots')) return;
    var nav = document.createElement('div');
    nav.className = 'tw-gallery-dots';
    // Skærmlæser-tekst; butikken er kun på dansk (Turbos galleri-markup har ingen oversat tekst til dette)
    var label = 'Billede %n af %t';
    var dots = [];
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tw-gallery-dots__dot';
      dot.setAttribute('aria-label', label.replace('%n', i + 1).replace('%t', count));
      dot.addEventListener('click', flkty.select.bind(flkty, i, false, false));
      nav.appendChild(dot);
      dots.push(dot);
    }
    function mark() {
      dots.forEach(function (d, i) {
        var active = i === flkty.selectedIndex;
        d.classList.toggle('is-selected', active);
        d.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    flkty.on('select', mark);
    mark();
    gallery.parentNode.insertBefore(nav, gallery.nextSibling);
  }

  // R7 – "Læs mere" på lange beskrivelser

  function initReadMore() {
    var boxes = document.querySelectorAll('[data-tw-readmore]');
    Array.prototype.forEach.call(boxes, function (box) {
      var content = box.querySelector('[data-tw-readmore-content]');
      var toggle = box.querySelector('[data-tw-readmore-toggle]');
      if (!content || !toggle) return;

      box.classList.add('is-clamped');
      // Kun knap, hvis teksten faktisk er længere end den forkortede visning
      if (content.scrollHeight <= content.clientHeight + 8) {
        box.classList.remove('is-clamped');
        return;
      }
      toggle.hidden = false;

      toggle.addEventListener('click', function () {
        var expanded = box.classList.toggle('is-clamped') === false;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        if (!expanded) box.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  // R7 – links til en sektion (fx "Om produktet") åbner den, hvis kunden har lukket den

  function openSectionFromHash(hash) {
    if (!hash || hash.length < 2) return;
    var target = document.getElementById(hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  }

  function initSectionLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href^="#tw-"]');
      if (link) openSectionFromHash(link.getAttribute('href'));
    });
    openSectionFromHash(window.location.hash);
  }

  // R8 – "Vis alle N specifikationer" (uden JS vises hele tabellen)

  function initSpecs() {
    var tables = document.querySelectorAll('[data-tw-specs-collapsible]');
    Array.prototype.forEach.call(tables, function (specs) {
      var toggle = specs.querySelector('[data-tw-specs-toggle]');
      if (!toggle) return;
      specs.classList.add('is-collapsed');
      toggle.hidden = false;
      toggle.addEventListener('click', function () {
        var expanded = specs.classList.toggle('is-collapsed') === false;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        if (!expanded) specs.scrollIntoView({ block: 'nearest' });
      });
    });
  }

  // R10 – serier: "Vælg størrelse"-listen navigerer til varen; filter i serietabellen

  function initSeries() {
    var select = document.querySelector('[data-tw-series-select]');
    if (select) {
      select.addEventListener('change', function () {
        if (select.value) window.location.href = select.value;
      });
    }

    var input = document.querySelector('[data-tw-series-filter]');
    var table = document.querySelector('[data-tw-series]');
    if (!input || !table) return;
    var rows = Array.prototype.slice.call(table.querySelectorAll('[data-tw-series-row]'));
    var count = table.querySelector('[data-tw-series-count]');
    var empty = table.querySelector('[data-tw-series-empty]');
    var countLabel = input.getAttribute('data-count-label') || '%n / %t';
    function normalize(text) {
      // "14 × 18", "14x18" og "14 x 18" skal matche hinanden
      return text.toLowerCase().replace(/[×x]/g, 'x').replace(/\s+/g, '');
    }
    var texts = rows.map(function (row) {
      return normalize(row.textContent);
    });
    input.addEventListener('input', function () {
      var q = normalize(input.value);
      var shown = 0;
      rows.forEach(function (row, i) {
        var match = !q || texts[i].indexOf(q) !== -1;
        row.hidden = !match;
        if (match) shown++;
      });
      if (count) count.textContent = q ? countLabel.replace('%n', shown).replace('%t', rows.length) : '';
      setHidden(empty, shown > 0);
    });
  }

  function init() {
    initVariantIds();
    initStock();
    initBilledeNote();
    initStickyAtc();
    initVariantWatcher();
    initReadMore();
    initSectionLinks();
    initSpecs();
    initGalleryDots();
    initSeries();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
